/**
 * Browser storage keys (localStorage / sessionStorage) used by the app, defined once so a key can
 * never drift between the writer and the reader. Prefix every key with `as-`.
 *
 * Note: `vuex-persistedstate` keys are configured in `src/store/store.js`, not here.
 */

/**
 * sessionStorage. Set when the owner/admin dismisses the "no plan chosen" banner; scoped per
 * organization by appending the organization id. Session-only on purpose: the banner returns on
 * the next login until a plan is chosen.
 */
export const SESSION_KEY_PLAN_BANNER_DISMISSED = 'as-plan-banner-dismissed'

/**
 * localStorage. The visitor's cookie choice — `accepted` or `declined` (src/domains/consent). Until
 * it is set, no analytics or tracking script is loaded; the choice itself is necessary storage.
 */
export const LOCAL_KEY_TRACKING_CONSENT = 'as-tracking-consent'

/**
 * localStorage. The contact a guest asked us to remember on the booking form ("Atcerēties manus
 * datus nākamajām reizēm"). Written only when that checkbox is ticked, removed as soon as it is
 * unticked — the consent is the checkbox, so nothing here may be written without it.
 *
 * These four keep their original names and therefore miss the `as-` prefix on purpose: renaming
 * them would silently drop the data people already have remembered on their machines.
 */
export const LOCAL_KEY_JOIN_NAME = 'join-name'
export const LOCAL_KEY_JOIN_MOBILE = 'join-mobile'
export const LOCAL_KEY_JOIN_EMAIL = 'join-email'
export const LOCAL_KEY_JOIN_ATTENDEE_NAME = 'join-participant-attendee-name'
